import { auth, db } from 'src/config/firebase';

const getGroups = async (serviceId) => {
  const currentDate = new Date().getTime();

  try {
    const snapshot = await db
      .ref('Groups')
      .orderByChild('serviceId')
      .equalTo(serviceId)
      .once('value');
    const data = await snapshot.val();

    const arr = [];
    for (const val in data) {
      let endDate = new Date(data[val].endDate * 1000).getTime();
      const automaticPayment = data[val]?.automaticPayment;
      const stripeEnd = data[val]?.stripeEnd;
      const subscriptionEndDate = data[val]?.subscriptionEndDate;
      const automaticCondition = automaticPayment ? (stripeEnd === 'endDate' ? new Date(subscriptionEndDate*1000) > currentDate : true) : true;
      if ((endDate >= currentDate || data[val].availableSeats > 0) && automaticCondition) {
        arr.push(data[val]);
      }
    }
    return arr;
  } catch (error) {
    console.warn('Error fetching groups: ', error.message);
  }
};

export default getGroups;
